import { render } from "./spinner.vue?vue&type=template&id=5d2c46ea"
import script from "./spinner.vue?vue&type=script&lang=js"
export * from "./spinner.vue?vue&type=script&lang=js"

import "./spinner.vue?vue&type=style&index=0&id=5d2c46ea&lang=css"
script.render = render

export default script